import _slicedToArray from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children", "shadow", "textAlign", "width", "height", "overflow", "backgroundColor", "padding", "isOpen", "onOpen", "size", "scroll", "handleClose"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useState, useEffect } from "react";
import { string, bool } from "prop-types";
import ReactDom from "react-dom";
import Styled, { css } from "styled-components";
import Icons from "@uprise/icons";
var Content = Styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n \tdisplay: block;\n\tz-index: 3000;\n\tborder-radius: 10px;\n\tposition: relative;\n\n\t", "\n\n\t", "\n\t", "\n\t", "\n\t", ";\n\t", ";\n    ", ";\n\t", ";\n\n    ", ";\n\n    ", ";\n    \n\n\t@media (max-width: 475px) {\n\t\twidth: 100%;\n\t\tmax-height: 100%;\n\t\toverflow: scroll;\n\t\tmargin: 0px 25px;\n\t}\n"])), function (props) {
  return props.shadow && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      box-shadow: 0 4px 10px 0 rgba(219, 221, 227, 0.5);\n    "])));
}, function (props) {
  return props.border && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      border: ", ";\n    "])), props.border);
}, function (props) {
  return props.backgroundColor && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), props.backgroundColor);
}, function (props) {
  return props.padding && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      padding: ", ";\n    "])), props.padding);
}, function (props) {
  return props.width && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      width: ", ";\n    "])), props.width);
}, function (props) {
  return props.height && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      height: ", ";\n    "])), props.height);
}, function (props) {
  return props.overflow && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      overflow: ", ";\n      "])), props.overflow);
}, function (props) {
  return props.textAlign && css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      text-align: ", ";\n    "])), props.textAlign);
}, function (props) {
  return props.scroll && css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        max-height: 100%;\n      "])));
}, function (props) {
  return props.scroll && css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n        overflow-y: auto;\n      "])));
});
var Background = Styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\tbackground: rgba(47, 45, 64, 0.6);\n\tposition: fixed;\n\tz-index: 1040;\n\tdisplay: block;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\toutline: 0;\n"])));
var CloseWrapper = Styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral([""])));
var CloseButton = Styled.img(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      width: 16px;\n      height: 16px;\n      text-align: right;\n      cursor: pointer;\n      right: 20px;\n      top: 20px;\n      position: absolute;\n"])));
var ModalWrapper = Styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 2000;\n\tmargin: 40px auto;\n"])));
export var Modal = function Modal(_ref) {
  var children = _ref.children,
      shadow = _ref.shadow,
      textAlign = _ref.textAlign,
      width = _ref.width,
      height = _ref.height,
      overflow = _ref.overflow,
      backgroundColor = _ref.backgroundColor,
      padding = _ref.padding,
      isOpen = _ref.isOpen,
      onOpen = _ref.onOpen,
      size = _ref.size,
      scroll = _ref.scroll,
      handleClose = _ref.handleClose,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      scrollPos = _useState4[0],
      setScrollPos = _useState4[1];

  var modalRoot = document.getElementById("root-modal");
  useEffect(function () {
    onOpen();
    window.addEventListener("keydown", _onEscKeyDown, false);
    return function () {
      return window.removeEventListener("keydown", _onEscKeyDown, false);
    };
  }, []);
  useEffect(function () {
    setShowModal(isOpen);
  }, [isOpen]);

  var _onEscKeyDown = function _onEscKeyDown(e) {
    if (e.key !== "Escape") return;
    setShowModal(false);
    handleClose();
  };

  if (showModal) {
    return ReactDom.createPortal( /*#__PURE__*/React.createElement(CloseWrapper, {
      onClick: function onClick() {
        return handleClose();
      }
    }, /*#__PURE__*/React.createElement(ModalWrapper, _extends({}, props, {
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }), /*#__PURE__*/React.createElement(Content, {
      textAlign: textAlign,
      width: width,
      height: height,
      overflow: overflow,
      padding: padding,
      scroll: scroll,
      backgroundColor: backgroundColor
    }, /*#__PURE__*/React.createElement(CloseButton, {
      src: Icons.close,
      onClick: function onClick() {
        return handleClose();
      }
    }), children), /*#__PURE__*/React.createElement(Background, null))), modalRoot);
  } else {
    return null;
  }
}; // array, bool, func, number, object, string
// symbol, node, element, elementType
// instanceOf oneOf oneOfType shape, exact, func, any

Modal.propTypes = {
  className: string,
  padding: string,
  width: string,
  height: string,
  overflow: string,
  border: string,
  shadow: bool,
  backgroundColor: string,
  scroll: bool
};
Modal.defaultProps = {
  onClick: function onClick() {
    return null;
  },
  onOpen: function onOpen() {
    return null;
  },
  shadow: true,
  scroll: false
};